import _ from 'lodash';
import { SHOP_STATUS, AFTERSALE_STATUS, ORDER_COLOR_LABEL, TAG_TYPE, KUAIDI_TYPE } from '@/constants';
import { MessageBox, Message } from 'element-ui';
import { autoLoading, request, createSourceFormDialog } from 'beans-admin-plugin';

export const orderItemColumns = [
  {
    prop: 'id',
    label: '编号',
    width: 80
  },
  {
    prop: 'sku_id',
    label: 'sku',
    width: 120
  },
  {
    prop: 'properties_value',
    label: '规格',
    width: 140,
    renderCell(h, { row }) {
      return (
        <c-link-button to={{ name: 'products.show', params: { id: row.product_id } }}>
          { row.properties_value }
        </c-link-button>
      );
    }
  },
  {
    prop: 'goods_shared_cover',
    label: '图片',
    renderCell: 'image',
    width: 120
  },
  {
    prop: 'qty',
    label: '数量',
    width: 80
  },
  {
    prop: 'real_base_price',
    label: '实际单价',
    width: 120
  }
];

export default function({
  actionColumn = {},
  resource = 'orders'
} = {}) {
  return [
    {
      prop: 'id',
      label: '编号',
      width: 80
    },
    {
      prop: 'so_id',
      label: '订单编号',
      width: 150,
    },
    {
      prop: 'order_items',
      label: '订单项',
      width: 60,
      type: 'expand',
      renderCell(h, { row }) {
        return <c-source-table style={{ width: '660px' }} table={{ data: row.order_items }} columns={orderItemColumns} />
      }
    },
    {
      prop: 'freight',
      label: '运费',
      width: 60,
      action: ['hide-in-table']
    },
    {
      prop: 'pay_amount',
      label: '支付金额',
      width: 100,
      sort: 'order_by'
    },
    {
      prop: 'shop_status',
      label: '订单状态',
      width: 100,
      renderCell(h, { row }) {
        return <el-tag type={TAG_TYPE[row.shop_status]}>{ SHOP_STATUS[row.shop_status] }</el-tag>;
      }
    },
    {
      prop: 'after_sale_shop_status',
      label: '最新售后状态',
      width: 150,
      renderCell(h, { row }) {
        const last_after_sale = row.after_sales.slice(-1)[0];
        if (last_after_sale) {
          const id = last_after_sale.id;
          const status = last_after_sale.shop_status;
          return (
            <c-link-button to={{ name: 'after_sales.show', params: { id: id } }}>
              { <el-tag type={TAG_TYPE[status]} style="text-decoration: underline;">{AFTERSALE_STATUS[status]}</el-tag> }
            </c-link-button>
          );
        }
      }
    },
    {
      prop: 'logistic_l_id',
      label: '快递单号',
      width: 130,
      renderCell(h, { row }) {
        if (row.logistic_id) {
          return <c-link-button to={{ name: 'logistics.show', params: { id: row.logistic_id } }}>{ row.logistic_l_id }</c-link-button>
        }
      }
    },
    {
      prop: 'buyer_account',
      label: '买家账号',
      width: 110,
      'show-overflow-tooltip': true,
      renderCell(h, { row }) {
        if (row.user_id) {
          return (
            <c-link-button to={{ name: 'users.show', params: { id: row.user_id } }}>
              { row.buyer_account || `ID${row.user_id}` }
            </c-link-button>
          )
        }
      }
    },
    {
      prop: 'cost_integral',
      label: '抵扣积分',
      width: 100,
      sort: 'order_by',
      action: ['hide-in-table']
    },
    {
      prop: 'successful_real_refund',
      label: '成功退款金额',
      width: 100,
      action: ['hide-in-table']
    },
    {
      prop: 'pay_amount_without_refund',
      label: '可退金额',
      width: 90,
      action: ['hide-in-table']
    },
    {
      prop: 'user_inviter',
      label: '邀请者',
      width: 100,
      renderCell(h, { row }) {
        if (row.user_inviter_id) {
          return (
            <c-link-button to={{ name: 'users.show', params: { id: row.user_inviter_id } }}>
              { row.user_inviter_nickname || `ID${row.user_inviter_id}` }
            </c-link-button>
          )
        }
      }
    },
    {
      prop: 'receiver_info',
      label: '收货信息',
      'show-overflow-tooltip': true,
    },
    {
      prop: 'order_date',
      label: '下单时间',
      renderCell: 'time',
      width: 120,
      sort: 'order_by'
    },
    {
      prop: 'wechat_paid_date',
      label: '支付时间',
      renderCell: 'time',
      width: 120
    },
    {
      prop: 'buyer_message',
      label: '买家留言',
      'show-overflow-tooltip': true
    },
    {
      prop: 'remark',
      label: '卖家备注',
      'show-overflow-tooltip': true,
      action: ['update'],
      form: {
        component: 'input',
        props: {
          type: 'textarea'
        }
      }
    },
    {
      prop: 'color_label',
      label: '颜色备注',
      width: 80,
      renderCell(h, { row }) {
        return row.color_label && <el-tag color={row.color_label} />
      },
      action: ['update'],
      form: {
        component: 'radioGroup',
        props: {
          radios: _.map(ORDER_COLOR_LABEL, (colorName, colorVal) => ({
            title: colorName,
            label: colorVal
          }))
        }
      }
    },
    _.merge({
      prop: 'action',
      label: '操作',
      width: 100,
      fixed: 'right',
      detail: true,
      edit: true,
      extraAction: (h, scope) => {
        const { row } = scope;
        const { VUE_APP_ENV } = process.env;
        const showFakeShipping = VUE_APP_ENV !== 'production' && row.shop_status === 'wait_seller_send_goods';
        const showEraseColor = !!row.color_label;
        const showDirectRefund = row.can_direct_refund_or_offline_taking;
        const showOfflineTaking =  row.can_direct_refund_or_offline_taking;
        const showCloseOrder = !row.wechat_paid_date && row.shop_status !== 'trade_closed';
        // 非自提、待发货和已发货、上传物流信息次数小于2
        const showFillExpress = !row.is_self_pick && (row.shop_status === 'wait_seller_send_goods' || row.shop_status === 'wait_buyer_confirm_goods') && row.upload_logistics_to_wechat_times < 2;
        const showAsMemberOrder = row.as_member_order_id;
        const goAfterSale = row.after_sales.length > 0;

        const fakeShipping = async() => {
          await MessageBox.confirm('该功能为配合前期测试发货，走通整个流程使用，并不是真的发货!');
          await autoLoading(request.put(`/${resource}/${row.id}/fake_shipping`));
          Message.success('测试发货完成');
          this.fetchData();
        }

        const eraseColor = async() => {
          await MessageBox.confirm('确定消色？');
          await autoLoading(request.put(`/${resource}/${row.id}/erase_color`));
          Message.success('消色完成');
          this.fetchData()
        }

        const directRefund = async() => {
          await MessageBox.confirm('确定直接退款？');
          await autoLoading(request.put(`/${resource}/${row.id}/direct_refund`));
          Message.success('退款完成');
          this.fetchData()
        }

        const offlineTaking = async() => {
          await MessageBox.confirm('该功能只使用于线下活动，当场支付拿货场景!');
          await autoLoading(request.put(`/${resource}/${row.id}/offline_taking`));
          Message.success('线下取货完成');
          this.fetchData();
        }

        const closeOrder = async() => {
          await MessageBox.confirm('确定关闭订单?');
          await autoLoading(request.put(`/${resource}/${row.id}/close`));
          Message.success('订单已关闭');
          this.fetchData();
        }

        const fillExpress = (h) => {
          debugger
          const columns = [
            {
              prop: 'lc_id',
              label: '物流公司',
              form: {
                component: 'select',
                required: true,
                props: {
                  clearable: false,
                  options: _.map(KUAIDI_TYPE, (label, value) => ({ label, value })),
                  defaultValue: row.logistic_lc_id
                }
              }
            },
            {
              prop: 'l_id',
              label: '快递单号',
              form: {
                required: true,
                component: 'input',
                props: {
                  defaultValue: row.logistic_l_id
                }
              }
            }
          ];

          const onConfirm = async (data) => {
            if (row.logistic_l_id) {
              await MessageBox.confirm('微信仅允许修改一次物流信息，是否确认修改？');
            }
            await request.post(`/orders/${row.id}/logistics`, data);
            Message.success('填写物流信息完成');
            this.fetchData();
          }
          createSourceFormDialog(h, {
            title: '填写物流信息',
            columns,
            onConfirm,
            customClass: 'w-30 min-w-400'
          })
        }

        return [
          showFakeShipping && {
            text: '测试发货',
            handler: fakeShipping
          },
          showEraseColor && {
            text: '消色',
            handler: eraseColor
          },
          showDirectRefund && {
            text: '直接退款',
            handler: directRefund
          },
          showOfflineTaking && {
            text: '线下取货',
            handler: offlineTaking
          },
          showCloseOrder && {
            text: '关闭订单',
            handler: closeOrder
          },
          showFillExpress && {
            text: row.logistic_l_id ? '更新物流信息' : '填写物流信息发货',
            handler: fillExpress
          },
          showAsMemberOrder && {
            text: '购买会员记录',
            handler: () => {
              this.$router.push({ name: 'as_member_orders.show', params: { id: row.as_member_order_id } });
            }
          },
          goAfterSale && {
            text: '查看售后',
            handler: () => {
              this.$router.push({ name: 'after_sales.index', query: { order_id_eq: row.id } });
            }
          },
          {
            text: '导出订单详情',
            handler: async () => {
              await this.$download({
                url: `/orders/${row.id}/export_detail`,
                params: {},
                name: _.get(this.$route, 'meta.title', 'resource') + '详情.xlsx'
              });
            }
          }
        ]
      }
    }, actionColumn)
  ].filter(Boolean)
}
